module.exports = __webpack_public_path__ + "static/img/question.f0ffb37.png";


//////////////////
// WEBPACK FOOTER
// ./static/mobile/question.png
// module id = W9iN
// module chunks = 1